import { Component, Prop, Inject, Watch } from 'vue-property-decorator'
import MergeHooks from "@/decorators/mergeHooks";
import R from "ramda";
import getLang from "@/components/RenderUtils/utils/lang";
import {
  WORK_STATION_TYPE,
  Types,
  getCascaderFunction,
  ACLS,
} from "@/components/RenderUtils/utils/constants";
import {
  tranformOptionsShape,
  getDeleteFunction,
  getRenameKeysFunction,
} from "@/components/RenderUtils/utils/index";
import renderUtils from "@/components/RenderUtils";
import getStyles from "@/components/RenderUtils/utils/style";
import "../style/workstationSetting.less";
import { WorkStationWorkingConditionParamSettingServiceProxy } from "@/service-proxies/app-v2/workStation.service-proxies";
import { DictServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import { exportWorkParams, importWorkParams } from "@/api/api";
import { IotAppSettingServiceProxy, IotAppPropertyServiceProxy } from '@/service-proxies/app-v2/iot-console.service-proxies'
const dictService = new DictServiceProxy();
const paramSettingService = new WorkStationWorkingConditionParamSettingServiceProxy();
const iassp = new IotAppSettingServiceProxy();
const iapsp = new IotAppPropertyServiceProxy();

@Component
@MergeHooks
export default class ParameterSetting extends renderUtils {
  @Inject() readonly refresh!: any;
  @Prop() workstation!: any;
  @Prop() workstationId!: any;
  @Prop({ default: () => [] }) readonly sourceData: Array<any>;
  @Prop({ default: () => true }) readonly showHeader: boolean;
  showModal = false;
  editdata = {};
  importData = {};
  showImportModal = false;
  dictOpts = [];
  iots = [];
  iotAppOptions = [];
  newIotAppOptions = [];
  iotAppParamOptions = [];
  newIotAppParamOptions = [];
  type: Types = Types.create;
  selects = [];
  selectedIotCode = ''
  currentIotVersion = null

  get lang() {
    return getLang(this);
  }

  get columns() {
    return [
      {
        title: this.lang.workstation_data,
        dataIndex: "paramDesc",
        key: "paramDesc",
        width: 120,
        ellipsis: true
      },
      {
        title: this.lang.business_type,
        dataIndex: "bizType",
        key: "bizType",
        customRender: (code) => {
          const find = this.dictOpts.find((item) => item.value == code);
          return find && find.label;
        },
        width: 120,
        ellipsis: true
      },
      {
        title: this.lang.unit,
        dataIndex: "unit",
        key: "unit",
        width: 120,
        ellipsis: true
      },
      {
        title: this.lang.related_iot,
        dataIndex: "iotCode",
        key: "iotCode",
        width: 120,
        ellipsis: true
      },
      {
        title: this.lang.related_collections,
        dataIndex: "iotAppParamDesc",
        key: "iotAppParamDesc",
        width: 120,
        ellipsis: true
      },
      {
        title: this.lang.related_iot_app,
        dataIndex: "iotAppCode",
        key: "iotAppCode",
        ellipsis: true
      },
    ];
  }

  get schema() {
    return {
      paramDesc: {
        label: this.lang.workstation_data,
        type: "input",
        placeholder: this.$t('common_please_input') + this.lang.workstation_data,
        rules: [
          {
            required: true,
            message: this.lang.workstation_data_required,
          },
        ],
      },
      bizType: {
        label: this.lang.business_type,
        type: "select",
        options: this.dictOpts,
        placeholder: this.$t('please_select') + this.lang.business_type,
        // disabled: ,
        rules: [
          {
            required: true,
            message: this.lang.business_type_required,
          },
        ],
      },
      unit: {
        label: this.lang.unit,
        type: "input",
        placeholder: this.$t('common_please_input') + this.lang.unit,
      },
      iotId: {
        multiKeys: {
          iotName: "iotName",
          iotCode: "iotCode",
        },
        placeholder: this.$t('please_select') + this.lang.iot,
        disabled: !!this.type,
        label: this.lang.iot,
        type: "select",
        options: this.iots,
        on: {
          change: (val, e, arr)=>{
            e.resetFields('iotAppId')
            e.resetFields('iotAppParamId')
            let iotCode = arr.find(item=>item.value===val).rest.iotCode
            let iotVersion = arr.find(item=>item.value===val).rest.iotVersion
            this.currentIotVersion = iotVersion
            if (iotVersion === 1) { // 新网关
              this.selectedIotCode = iotCode
              this.emitCascader('newIotAppOptions', 'name', 'id')(iotCode)
            } else {
              this.emitCascader('iotAppOptions', 'name', 'gatewayAppId')(val)
            }
          },
        },
        rules: [
          {
            required: true,
            message: this.lang.iot_required,
          },
        ],
      },
      iotAppId: {
        multiKeys: {
          // iotAppCode: this.currentIotVersion === 1 ? 'code' : 'name'
          iotAppCode: 'name'
        },
        disabled: !!this.type,
        label: this.lang.iot_app,
        type: "select",
        placeholder: this.$t('please_select') +  this.lang.iot_app,
        options: this.currentIotVersion === 1 ? this.newIotAppOptions : this.iotAppOptions,
        on: {
          change: (val, e, arr)=>{
            e.resetFields('iotAppParamId')
            let appCode = arr.find(item=>item.value===val).rest.code
            if (this.currentIotVersion === 1) { // 新网关
              this.emitCascader("newIotAppParamOptions", "name", "id")(appCode)
            } else {
              this.emitCascader("iotAppParamOptions", "name", "id")(val)
            }
          },
        },
        rules: [
          {
            required: true,
            message: this.lang.iot_app_required,
          },
        ],
      },
      iotAppParamId: {
        multiKeys: {
          iotAppParamDesc: "name",
        },
        disabled: !!this.type,
        label: this.lang.iot_app_param,
        type: "select",
        placeholder: this.$t('please_select') + this.lang.iot_app_param,
        options: this.currentIotVersion === 1 ? this.newIotAppParamOptions : this.iotAppParamOptions,
        rules: [
          {
            required: true,
            message: this.lang.iot_app_param_required,
          },
        ],
      },
    };
  }

  get importSchema() {
    return {
      iotId: {
        multiKeys: {
          iotName: "iotName",
          iotCode: "iotCode",
          iotVersion: "iotVersion"
        },
        disabled: !!this.type,
        label: this.lang.iot,
        type: "select",
        options: this.iots,
        on: {
          // change: this.emitCascader("iotAppOptions", "name", "gatewayAppId"),
          change: (val, e, arr)=>{
            e.resetFields('iotAppId')
            let iotCode = arr.find(item=>item.value===val).rest.iotCode
            let iotVersion = arr.find(item=>item.value===val).rest.iotVersion
            this.currentIotVersion = iotVersion
            if (iotVersion === 1) { // 新网关
              this.selectedIotCode = iotCode
              this.emitCascader('newIotAppOptions', 'name', 'id')(iotCode)
            } else {
              this.emitCascader('iotAppOptions', 'name', 'gatewayAppId')(val)
            }
          },
        },
        rules: [
          {
            required: true,
            message: this.lang.iot_required,
          },
        ],
      },
      iotAppId: {
        multiKeys: {
          iotAppCode: this.currentIotVersion === 1 ? 'code' : '',
          iotAppName: 'name'
        },
        disabled: !!this.type,
        label: this.lang.iot_app,
        type: "select",
        // options: this.iotAppOptions,
        options: this.currentIotVersion === 1 ? this.newIotAppOptions : this.iotAppOptions,
        rules: [
          {
            required: true,
            message: this.lang.iot_app_required,
          },
        ],
      },
      file: {
        type: "uploadFile",
        label: this.$t("page_workstation_maintain_choose_file"),
        props: {
          accept: ".json",
        },
        rules: [
          {
            required: true,
            message: this.$t("page_workstation_maintain_must_choose_file"),
          },
        ],
      },
    };
  }

  async mounted() {
    const { data } = await dictService.dictionary(WORK_STATION_TYPE);
    const dictOpts = tranformOptionsShape("dictValue", "dictKey")(data);
    dictOpts.forEach((item) => (item.value = Number(item.value)));
    this.dictOpts = dictOpts;
  }

  render() {
    const props = {
      columns: this.columns,
      dataSource: this.sourceData,
      key: this.sourceData,
      actions: {
        edit: {
          acl: ACLS.EDIT_PARAM,
          action: this.getOpenModalFunction(Types.edit),
        },
        // del: {
        //   acl: ACLS.EDIT_PARAM,
        //   action: this.deleteParamter,
        // },
      },
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selects = selectedRowKeys;
        },
      },
      scroll: {x:840}
    };
    return (
      <blank-view
        bodyStyle={getStyles("wrapper", "margBtm8")}
        mainStyle={getStyles("transparent")}
        class="paramter-setting"
      >
        <div style={getStyles("header")}>
          <p style={getStyles("pHeader")} v-show={this.showHeader}>
            {this.lang.parameter_setting}
            <a-popconfirm
              title={this.$t("page_resource_pool_confirm_delete")}
              onConfirm={this.deleteParamter}
              okText={this.$t("yes")}
              cancelText={this.$t("no")}
            >
              <a
                style={`color:${
                  this.selects.length ? "red" : "rgba(0,0,0,.25)"
                };margin-left:16px;`}
                disabled={this.selects.length < 1}
                v-acl={ACLS.DELETE_PARAM}
              >
                {this.$t("delete")}
              </a>
            </a-popconfirm>
          </p>
          <a-button-group>
            <a-button
              type="link"
              style="padding-bottom: 1em;"
              onClick={this.export}
              v-acl={ACLS.EXPORT_PARAM}
            >
              {this.$t('page_product_export')}
            </a-button>
            <a-button
              type="link"
              style="padding-bottom: 1em;"
              onClick={this.openImportModal}
              v-acl={ACLS.IMPORT_PARAM}
            >
              {this.$t('page_business_data_import_product')}
            </a-button>
            <a-button
              type="link"
              style="padding-bottom: 1em;"
              onClick={() => this.getOpenModalFunction(Types.create)({})}
              v-acl={ACLS.CREATE_PARAM}
            >
              {this.lang.create}
            </a-button>
          </a-button-group>
        </div>
        {this.renderTable(props)}
        {this.renderModal()}
        {this.renderImportModal()}
      </blank-view>
    );
  }

  renderImportModal() {
    const props = {
      title: this.$t("page_business_data_import_product"),
      show: this.showImportModal,
      schema: this.importSchema,
      editdata: this.importData,
      ok: this.import,
      cancel: this.setState("showImportModal"),
      ref: "import",
      footer: "default",
      bodyStyle: {
        paddingBottom: "32px",
      },
    };
    return this.renderDialogWithForm(props);
  }

  renderModal() {
    const props = {
      show: this.showModal,
      schema: this.schema,
      type: this.type,
      ref: "create",
      footer: "default",
      ok: this.getSumbitFunction(this.type),
      cancel: this.setState("showModal"),
      editdata: this.editdata,
      title: this.type === Types.create ? this.lang.create : this.lang.edit,
    };
    return this.renderDialogWithForm(props);
  }

  getSumbitFunction(type) {
    const typeMap = {
      [Types.create]: this.parameterCreateFn,
      [Types.edit]: this.parameterModifyFn,
    };
    return R.prop(type, typeMap);
  }

  parameterCreateFn(data) {
    const effectCb = () => {
      this.$message.success(this.lang.create_success);
      this.refresh.parameterSetting();
      this.setState("showModal")(false);
    };

    const mergeForm = R.pipe(
      R.pick(["id", "code"]),
      getRenameKeysFunction({
        id: "workStationId",
        code: "workStationCode",
      })
    )(this.workstation);

    R.pipe(
      R.merge(mergeForm),
      paramSettingService.createWorkingConditionParam.bind(paramSettingService),
      R.andThen(effectCb)
    )(data);
  }

  parameterModifyFn(data) {
    const items = this.iots.find(item=>item.value===data.iotId)
    if (items && items.rest && items.rest.iotApps && items.rest.iotApps.length){
      const code = items.rest.iotApps.find(item=>item.id===data.iotAppId)
      data.iotAppCode = code.name
    }
    const effectCb = () => {
      this.$message.success(this.lang.modify_success);
      this.refresh.parameterSetting();
      this.setState("showModal")(false);
    };
    R.pipe(
      R.converge(
        paramSettingService.updateWorkingConditionParam.bind(
          paramSettingService
        ),
        [R.omit(["id"]), R.prop("id")]
      ),
      R.andThen(effectCb)
    )(data);
  }

  emitCascader(type, label, value) {
    const fetchFn = getCascaderFunction(type);
    const setState = this.setState(type);
    const isParam = () => R.equals("iotAppParamOptions", type);
    const isParam1 = () => R.equals("newIotAppOptions", type); // newIotAppOptions：新网关应用列表
    const isParam2 = () => R.equals("newIotAppParamOptions", type); // newIotAppParamOptions：新网关应用属性列表
    if(isParam2()) {
      return async (appCode) => {
        console.log(appCode)
        await R.pipe(
          iapsp.getIotAppPropertyList.bind(iapsp),
          R.andThen(
            R.pipe(
              R.when(isParam2, R.prop("items")),
              tranformOptionsShape(label, value),
              setState
            )
          )
        )(appCode, this.selectedIotCode);
      }
    } else {
      return async (id) => {
        console.log(type, label, value, id)
        await R.pipe(
          fetchFn,
          R.andThen(
            R.pipe(
              R.when(isParam, R.prop("records")),
              R.when(isParam1, R.prop("items")),
              R.when(isParam2, R.prop("items")),
              tranformOptionsShape(label, value),
              setState
            )
          )
        )(id);
      };
    }
  }

  openImportModal() {
    this.emitCascader("iots", "iotCode", "iotId")(this.workstationId);
    this.importData = {
      workStationCode: this.workstation.code,
      workStationId: this.workstationId,
    };
    this.newIotAppOptions = []
    this.iotAppOptions = []
    this.showImportModal = true;
  }

  getOpenModalFunction(type) {
    return async (row) => {
      console.log(row)
      this.newIotAppOptions = [];
      this.iotAppOptions = [];
      this.newIotAppParamOptions = [];
      this.iotAppParamOptions = [];
      this.setState("editdata")(row);
      this.setState("showModal")(true);
      this.setState("type")(type);
      // 打开编辑弹框时立即获取所有下拉框的列表数据
      await this.emitCascader("iots", "iotCode", "iotId")(this.workstationId); // iot设备列表
      if (row.iotId) { // 根据新旧网关获取对应的iot设备应用列表
        let iotCode = this.iots.find(item=>item.value===row.iotId).rest.iotCode
        let iotVersion = this.iots.find(item=>item.value===row.iotId).rest.iotVersion
        console.log(iotCode,iotVersion)
        this.currentIotVersion = iotVersion
        if (iotVersion === 1) { // 新网关
          this.selectedIotCode = iotCode
          await this.emitCascader('newIotAppOptions', 'name', 'id')(iotCode)
        } else {
          await this.emitCascader('iotAppOptions', 'name', 'gatewayAppId')(row.iotId)
        }
      }
      if (row.iotAppId) { // 根据新旧网关获取对应的iot设备应用属性列表
        let iotAppList = this.currentIotVersion === 1 ? this.newIotAppOptions : this.iotAppOptions
        let appCode = iotAppList.find(item=>item.value===row.iotAppId).rest.code
        if (this.currentIotVersion === 1) { // 新网关
          this.emitCascader("newIotAppParamOptions", "name", "id")(appCode)
        } else {
          this.emitCascader("iotAppParamOptions", "name", "id")(row.iotAppId)
        }
      }
    };
  }

  deleteParamter() {
    const effectCb = () => {
      this.$message.success(this.lang.delete_success);
      this.refresh.parameterSetting();
      this.selects = [];
    };

    const fetchFn = paramSettingService.deleteWorkingConditionParam.bind(
      paramSettingService
    );

    R.pipe(fetchFn, R.andThen(effectCb))(this.selects);
  }

  async export() {
    const export_blob = await exportWorkParams(this.workstationId);
    const urlObject = window.URL || (window as any);
    const save_link = document.createElementNS(
      "http://www.w3.org/1999/xhtml",
      "a"
    ) as any;
    save_link.href = urlObject.createObjectURL(export_blob);
    save_link.download = `work-params.json`;
    const ev = document.createEvent("MouseEvents");
    ev.initMouseEvent(
      "click",
      true,
      false,
      window,
      0,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null
    );
    save_link.dispatchEvent(ev);
  }

  async import(data) {
    data.file = data.file[0];
    const fd = new FormData();
    Object.keys(data).forEach((key) => {
      fd.append(key, data[key]);
    });
    await importWorkParams(fd);
    this.$message.success(this.$t("page_workstation_maintain_upload_success"));
    this.showImportModal = false;
    this.refresh.parameterSetting();
  }
}
